import styled from "styled-components";
import buildColor from "../../_static/ColorPalette";
import { fontNormal } from "../../_static/Typography";

export const SectionContainer = styled.section`
  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  margin-top: 30px;
  @media (min-width: 486px) {
    margin-top: 40px;
  }
`;

export const RowContainerBig = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

export const Title = styled.h1`
  color: ${buildColor("white", "100")};
  font-family: ${fontNormal};
  font-weight: 700;
  margin-bottom: 4px;
  height: 100%;
  max-width: 480px;
  padding: 0;
  font-size: 16px;
  text-align: center;

  @media (min-width: 486px) {
    font-size: 28px;
  }
`;

export const Description = styled.p`
  color: ${buildColor("blue", "100")};
  font-family: ${fontNormal};
  font-weight: 400;
  font-size: 14px;
  max-width: 480px;
  padding: 0;
  text-align: center;
  @media (min-width: 486px) {
    font-size: 18px;
  }
`;
